import { Routes } from '@angular/router';
import { ecgRoutes } from '@core/components/telediagnosis-old/ecg/ecg.routes';
import { oscRoutes } from '@core/components/telediagnosis-old/osc/osc.routes';
import { postureRoutes } from '@core/components/telediagnosis/posture/posture.routes';
import { PatientNavigationEnum } from '../../navigation.enum';
import { PatientTelediagnosisComponent } from './patient-telediagnosis.component';

export const patientTelediagnosisRoutes: Routes = [
  {
    path: PatientNavigationEnum.telediagnosis,
    component: PatientTelediagnosisComponent,
    children: [
      {
        path: '',
        redirectTo: PatientNavigationEnum.osc,
        pathMatch: 'full',
      },
      {
        path: PatientNavigationEnum.osc,
        loadChildren: () => import('@core/components/telediagnosis-old/osc/osc.routes').then(() => oscRoutes),
      },
      {
        path: PatientNavigationEnum.ecg,
        loadChildren: () => import('@core/components/telediagnosis-old/ecg/ecg.routes').then(() => ecgRoutes),
      },
      {
        path: PatientNavigationEnum.joint_mobility,
        loadChildren: () => import('@core/components/telediagnosis/posture/posture.routes').then(() => postureRoutes),
      },
    ],
  },
];
